import { FileUp, LockKeyhole, Upload } from 'lucide-react';
import { useRef, useState } from 'react';

type FileDropZoneProps = {
  onFile: (file: File) => void;
  recentFileNames: string[];
};

export function FileDropZone({ onFile, recentFileNames }: FileDropZoneProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  const acceptFile = (files: FileList | null) => {
    const file = files?.[0];
    if (file) onFile(file);
  };

  return (
    <main className="landing-shell">
      <section
        className={`file-drop-zone ${dragging ? 'is-dragging' : ''}`}
        onDragEnter={(event) => {
          event.preventDefault();
          setDragging(true);
        }}
        onDragOver={(event) => event.preventDefault()}
        onDragLeave={(event) => {
          if (!event.currentTarget.contains(event.relatedTarget as Node | null)) setDragging(false);
        }}
        onDrop={(event) => {
          event.preventDefault();
          // The window-level drop listener in App imports the file.
          setDragging(false);
        }}
      >
        <div className="drop-icon" aria-hidden="true">
          <FileUp size={34} />
        </div>
        <p className="eyebrow">LOCAL DATALOG ANALYSIS</p>
        <h1>Turn a drive into a clear signal.</h1>
        <p className="landing-copy">
          Open an iDash CSV to build synchronized graphs, inspect exact samples, and measure any
          time range. Your datalog stays in this browser.
        </p>
        <button className="primary-button landing-button" onClick={() => inputRef.current?.click()}>
          <Upload size={18} /> Open iDash CSV
        </button>
        <p className="drop-hint">or drag a CSV anywhere into this panel</p>
        <input
          ref={inputRef}
          className="visually-hidden"
          type="file"
          accept=".csv,text/csv"
          aria-label="Open iDash CSV"
          onChange={(event) => acceptFile(event.currentTarget.files)}
        />
        <div className="privacy-note">
          <LockKeyhole size={16} />
          <span>No upload. No account. Local files never leave your device.</span>
        </div>
      </section>
      {recentFileNames.length > 0 && (
        <section className="recent-workspaces" aria-label="Saved workspace names">
          <p>Reopen a file to restore its saved graph layout</p>
          <div>
            {recentFileNames.slice(0, 4).map((name) => (
              <span key={name}>{name}</span>
            ))}
          </div>
        </section>
      )}
    </main>
  );
}
